import React, { Fragment } from "react";
import { uuid } from "../utils/files/functions";

/**
 * Checkbox React Component
 * Examples:
   <Checkbox disabled label="Texto" />
   <Checkbox label="Texto" checked={checked} onClick={checked => setChecked(checked)} />
 *
 *
 */
const Checkbox = ({
  disabled = false,
  className = "",
  label = "", // AGREGAR CUANDO SOLO SE MOSTRARA TEXTO
  checked = false,
  value = "",
  id = uuid(),
  tyc = true,
  htmlFor = true,
  hasSpan = null,
  onClick,
  hasError = null,
  clickedLabel = false,
  labelInnerHTML = false,
}) => {
  const onCliked = () => {
    if (onClick && !disabled) {
      onClick(!checked);
    }
  };

  const onClikedLabel = () => {
    if (clickedLabel) {
      onCliked();
    }
  };

  return (
    <Fragment>
      <div
        id={id}
        className={`rd--checkbox ${checked ? "is-checked" : ""} ${className} ${
          disabled ? "disabled" : ""
        }`.trim()}
      >
        <div className="rd--checkbox-box" onClick={onCliked}>
          <input
            type="checkbox"
            className="rd--checkbox-input"
            id={id}
            disabled={disabled}
            value={value}
            defaultChecked={checked}
          />
          <span className="rd--checkbox-checkmark"></span>
        </div>
        <div className="rd--checkbox__content">
          {!labelInnerHTML && (
            <label
              onClick={onClikedLabel}
              className={`rd--checkbox-label ${tyc ? "tyc" : ""}`.trim()}
              htmlFor={htmlFor ? id : null}
            >
              {label}
            </label>
          )}
          {labelInnerHTML && (
            <label
              onClick={onClikedLabel}
              className={`rd--checkbox-label ${tyc ? "tyc" : ""}`.trim()}
              htmlFor={htmlFor ? id : null}
              dangerouslySetInnerHTML={{ __html: label }}
            ></label>
          )}
          {hasSpan && (
            <div className="rd--checkbox__span" htmlFor={id}>
              {hasSpan}
            </div>
          )}
        </div>
      </div>

      {hasError ? (
        <span className="rd--checkbox-error" htmlFor={id}>
          {hasError}
        </span>
      ) : null}
    </Fragment>
  );
};

export default Checkbox;
